import { useAtom } from '@reatom/npm-react'
import { motion } from 'motion/react'
import { useCallback } from 'react'
import styled from 'styled-components'

import { useHapticFeedback } from '@blade/ui-kit'
import { UserAvatar } from '@root/entities/auth/ui'
import { basicModeAtom } from '@root/entities/basic'
import { BasicTopbarCash } from '@root/features/basic'
import { useAppRoutes } from '@root/features/routing'
import { settingScreenAtom } from '@root/features/settings/settings-screen/atoms'
import { profileTabAtom } from '@root/features/user/profile-header/atoms'
import { WalletsDropdown } from '@root/features/wallet/wallets-dropdown'
import { Gear2Icon } from '@root/shared/ui-kit'

import { HeaderSearchButton } from './header-search-button'

export const HeaderUser: React.FC = () => {
  const haptics = useHapticFeedback()
  const { navigateToProfileIndex } = useAppRoutes()
  const [, setSettingsScreen] = useAtom(settingScreenAtom)
  const [, setProfileTab] = useAtom(profileTabAtom)
  const [tradingMode] = useAtom(basicModeAtom)

  const handleProfileClick = useCallback(() => {
    haptics.impactOccurred('light')
    setProfileTab('stats')
    navigateToProfileIndex()
  }, [haptics, navigateToProfileIndex, setProfileTab])

  const handleSettingsClick = useCallback(() => {
    haptics.impactOccurred('light')
    setSettingsScreen('main')
  }, [haptics, setSettingsScreen])

  return (
    <>
      <HeaderSearchButton />
      {tradingMode === 'basic' ? <BasicTopbarCash /> : <WalletsDropdown />}
      <UserContainer
        initial={false}
        animate={{
          opacity: 1,
        }}
        style={{
          marginInlineStart: 4,
        }}
      >
        <SettingsButton type="button" onClick={handleSettingsClick}>
          <Gear2Icon size={22} />
        </SettingsButton>
        <UserAvatar size={28} onClick={handleProfileClick} />
        {/* TODO: support user states */}
      </UserContainer>
    </>
  )
}

const SettingsButton = styled.button`
  all: unset;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--text-9);
  padding: 0px;
  transition: color 0.2s ease-in-out;

  &:hover {
    color: var(--text-12);
  }
`

const UserContainer = styled(motion.div)`
  display: flex;
  justify-content: flex-end;
  background: var(--backgroundA-2);
  border-radius: 14px;
  gap: 2px;
`
